<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Bekleyen Servisler</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/create/Servis"><button type="submit" class="btn submit bg-dark text-light">Yeni Servis</button>
          </router-link>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div v-if="!progres.inprogres" class="row">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-12">
               <div class="pie-chart chart block">
                 <div class="title"><strong>Servis Nedenine göre (Anlık)</strong></div>
<apexchart type="pie" width="100%" :options="sn.chartOptions" :series="sn.series"></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Sağlayıcıya Göre  (Anlık)</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="bar" width="100%" :options="durum.chartOptions" :series="durum.series"></apexchart>
                  </div>
                </div>
          </div>
        </div>
        <div class="row mt-2 mb-2 mr-2">
                          <div class="col-9 text-right pl-0">
        <div class="row ml-3">
          <div class="col-4"><input class="form-control" type="date" v-model="d1"></div>
          <div class="col-4"><input class="form-control" type="date" v-model="d2"></div>
          <div class="col-4">
            <button @click="getPostsAsync('kayit',true)" class="btn btn-danger d-block">Filtrele</button>
          </div>
        </div>
      </div>
          <div class="col-lg-3 col-12 text-right">
              <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
          </div>
        </div>
     <div class="row">
          <div class="col-12">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Sağlayıcı</th>
                      <th>Müşteri</th>
                      <th>Tarih</th>
                      <th>Model</th>
                      <th>barkod</th>
                      <th>S.Nedeni</th>
                      <th>Süre</th>
                      <th>Yönlendir</th>
                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="post in filteredItems(posts,'ay')" :key="post.id">
                    <td>{{post.no}}</td>
                    <td class="dashtext-2">{{post.sa}}</td>
                    <td>{{post.cari_ad}}</td>
                    <td>{{$helper.trtgoster(post.tarih)}}</td>
                    <td>{{post.model}}</td>
                    <td>{{post.barkod}}</td>
                    <td class="dashtext-3">{{post.sn}}</td>
                    <td>{{$helper.gunhesapla(post.tarih)}} Gün</td>
                    <td v-if="$helper.sayfayetki(754931)">
                      <select @change="onChange($event, post.sid)" class="form-control">
                        <option selected value="0">Bölge</option>
                        <option v-for="bolges in bolge" :key="bolges.id" :value="bolges.id">{{bolges.alias}}</option>
                      </select>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>      
  </div>
</template>

<script>
export default {
   created() {
     this.progres.inprogres = true
     this.yetki()
     //this.getPostsAsync();
  },
  data () {
    return {
      sd :1, //bu sd ler ileride ktip gibi farklı table a alınabilir.
      posts : [],
      error :[],
      currentTag: 'All',
      donem : this.$request.donem(),
      durum:{},
      sn : {},
      bolge:[],
      ayar:this.$request.ayar(),
      table:'',
                        d1:this.$request.setFiltre().aylik.t1,
      d2:this.$request.setFiltre().aylik.t2,
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      }        
    }
  },
    methods : {

      yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                this.table = 'servis'
                baslat = true
                this.getPostsAsync(this.table,baslat)
            }
            else{
              this.table = 'kayit'
              baslat=true
              this.getPostsAsync(this.table,baslat)
            }
      },
save: function(event) {
			alert(event)
		},
        bolgegetir(){
          
          this.$request.get("bolge/"+this.ayar.firmaid)
          .then(res => {this.bolge = res.results
          this.progres.inprogres =false
          })
          .catch(err => (this.error.push(err)))

        },
        onChange(event,sid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Yönlendiriyorum...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
              if(result.value) {
                let islem = {
                  bid : event.target.value,
                  sid:sid,
                  sd : 2
                }
                  this.$request.post("yonlendir/",islem)
                  .then(res => {
                      let log ={
                        servis_id : res.data.sid,
                        tarih: new Date(),
                        saat :new Date(Date.now()),
                        sd:res.data.sd,
                        kid:this.ayar.kid,
                        islem: 'Servis Yönlendirildi'
                      }
                      this.$request.post("servis_log/",log)
                        .then(res => {
                            this.$swal('Yönlendirildi', 'İşlem Başarı ile tamamlandı', 'success')
                            this.getPostsAsync(this.table,true)
                        })
                        .catch(this.$swal('Cancelled', 'Log Kaydı Yapılamadı', 'danger'))
                  })
                  .catch(this.$swal('Cancelled', 'Hata ile karşılaşıldı', 'danger'))
              }
            })
        },
        getPostsAsync (table,baslat){
          if (baslat){
              this.$request.get("plansiz/"+this.ayar.ya+"/"+this.ayar.kid+'/'+this.sd+'/'+table)
              .then(res => {
            this.posts = res.results.sort((t1,t2) => t1.id < t2.id ? -1 : 1),
            this.aktarim(this.$helper.group2adet(res.results,'ay','sa'),
            this.sn = this.$helper.piechart(this.$helper.groupByAdet(res.results,'sn')),
            this.bolgegetir(),
            )
            })
          .catch(err => {this.error.push(err)})
          }  
        },
        filter: function(tag) {
          this.currentTag = tag;
        },
        filteredItems: function(array,field) {
          var filter = this.currentTag;
          if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
        },

        aktarim (data){
          var datas = [];
          var aylar = [];
            Object.keys(data).forEach(function(key) {
              Object.keys(data[key]).forEach(function(keys) {
                    Object.keys(data[key][keys]).forEach(function(keysi) {
                      let deneme = {
                            name:key,
                            data: data[key][keys][keysi]
                        }
                        datas.push(deneme);
                        //aylar.push(data[key])
                  })
              })
            })
              const result = []
              datas.forEach(function (a) {
                  if ( !this[a.name] ) {
                      this[a.name] = { name: a.name, data:[]};
                      result.push(this[a.name]);
                  } 
                  this[a.name].data.push(a.data);
              }, Object.create(null));
                  this.durum = {
                    series: result,
                    chartOptions: {
                      colors: ["#e83e8c","#723ac3","#EA8685","#864DD9","#a678eb"],
                      chart: {
                        type: 'bar',
                        foreColor: '#a5a7ab',
                        toolbar: {show: false,}
                      },
                      tooltip:{
                          enabled:false
                      },
                      xaxis: {
                        categories: ['Oca','Şub','Nis','May'],
                      },
                        fill: {
                        colors: ["#e83e8c","#723ac3","#EA8685","#864DD9","#a678eb"],
                        },                      
                    }
                  }
                 // console.log(result)
        },

     }
   }
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "No"; }
		td:nth-of-type(3):before { content: "Tarih"; }
		td:nth-of-type(4):before { content: "S.Nedeni"; }
		td:nth-of-type(5):before { content: "S.Kod"; }
		td:nth-of-type(6):before { content: "S.Durumu"; }
		td:nth-of-type(7):before { content: "S.Tipi"; }
		td:nth-of-type(8):before { content: "Guide"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/servis/bekleyen.vue